<template>
	<v-card
		outlined
	>
		<v-card-title
			class="text_primary"
		>
			{{ page_title }}

			<v-spacer></v-spacer>
            <v-btn
                class="mr-2 white--text"
                color="#5087e6"
                @click="createSetting"
            >
                新增
            </v-btn>
		</v-card-title>

		<v-divider></v-divider>
		<v-row class="mt-1 mb-1 pr-3">
			<v-col
				cols="12"
				lg="12"
				md="12"
				xs="12"
			>  
				<v-card-text
					class="d-flex align-center justify-end pa-0"
				>
					<p class="mb-0 pb-0 mr-3">顯示</p>
					<v-select
						style="max-width:7em;"
						outlined
						return-object
						@change="chagePerPage(selected_per_page)"
						v-model="selected_per_page"
						:items="per_page_items"
						item-value="value"
						item-text="name"
						hide-details
						dense
					>
					</v-select>
				</v-card-text>
			</v-col>
		</v-row>
		<v-divider></v-divider>

		<v-data-table
            :no-data-text="'沒有資料'"
            no-results-text="沒有資料"
			hide-default-footer
			:headers="headers"
			:items="datas"
			:items-per-page="selected_per_page.value"
		>
          <template v-slot:[`item.task_name`] = "{item}">
            <span>{{display_task_name[item.task_name] ? display_task_name[item.task_name]: ''}}</span>
          </template>


          <template v-slot:[`item.created_at`] = "{item}">
            <span>
                {{ item.created_at ? $utils.displayISOString(item.created_at) : item.created_at}}
            </span>
          </template>

          <template v-slot:[`item.finish_at`] = "{item}">
            <span>
                {{ item.finish_at ? $utils.displayISOString(item.finish_at) : item.finish_at}}
            </span>
          </template>

          <template v-slot:[`item.actions`] = "{item}">

            <v-btn
              class="text_default btn_default btn_default_bg_linear"
              outlined
              @click="downloadReport(item) "
            >
              下載
            </v-btn> 

            <!-- <v-btn
              class="btn_action btn_action_bg_linear mr-3"
              outlined
              @click="edit(item)"
            >
              編輯設定
            </v-btn> 

            <v-btn
			  
              class="btn-danger white--text"
              outlined
              @click="del(item)"
            >
              刪除
            </v-btn>        -->
          </template>
		</v-data-table>

		<div class="text-center mt-5">
			<Pagination
				v-if="page_setting.is_show"
				:setting="page_setting"
			/>
		</div>
	</v-card>
</template>
<script>
import Pagination from '@/components/Utils/Pagination.vue'
export default {
    name: 'WaterMarkerList',
    components: {
        Pagination
    },
    data: function() {
        return {	
            page_title: "浮水印",
            display_task_name: {
                outputInvoiceExcelData: '匯出發票資料'
            },
            display_file_name: {
                outputInvoiceExcelData: '發票資料'
            },
            is_loading: false,	
            datas: [],
            headers: [      
                {
                    text: '名稱',
                    sortable: false,
                    value: 'task_name',
                },
                {
                    text: '開始時間',
                    sortable: false,
                    value: 'created_at',
                },
                {
                    text: '結束時間',
                    sortable: false,
                    value: 'finish_at',
                },
                { 
                    text: '', 
                    sortable: false,
                    value: 'actions',
                    align: 'right',
                }, 					             
            ],
            page_setting: {
                is_show: false,
                selected_page: 1,
                total_page: 10,
                total_visible: 5,
            },
            selected_per_page: {
                name: "48筆",
                value: 48, 
            },
            per_page_items: [
                {
                    name: "10筆",
                    value: 10, 
                },
                {
                    name: "24筆",
                    value: 24, 
                },
                {
                    name: "48筆",
                    value: 48, 
                },
                {
                    name: "100筆",
                    value: 100, 
                },
            ],
        }
    },
    mounted: async function() {
        this.initData()
    },
    methods: {
        initData: async function(){
        },
        chagePerPage: async function(selected_per_page){
            let query = this.$route.query;
            let tmp_query = {...query, limit: selected_per_page.value, page: 1};
            console.log(tmp_query)
            try {
                await this.$router.push({ path: this.$route.path, query: tmp_query})
            } catch (err) {
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
            }
            await this.initData()
        },
        createSetting(){
            this.$router.push('edit')
        }
    },	
    computed: {
    }     
}
</script>
<style scoped>
</style>